import script from "./MiNTNewsListMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsListMobile.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsListMobile.vue?vue&type=style&index=0&id=5836b43e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5836b43e"]])

export default __exports__